/**
 * Module definition houses i18n implementation.
 *
 * @module stack.common.i18n
 */
angular.module('stack.common.i18n', [
  'stack.common.i18n.localize.stackLocalize',
  'stack.common.i18n.filters.localize',
  'stack.common.i18n.models.TranslationModel',
  'stack.common.i18n.resolvers.TranslationResolver',
  'stack.common.i18n.services.TranslationService'
]);
